import { Empty, Icon } from 'ui';

const CommentsEmpty = () => (
  <Empty
    description={{
      subtitle: 'Be first to add a comment and start a discussion',
      title: 'The conversation is about to begin',
    }}
    image={<Icon icon="chat-3-line" />}
  />
);

export default CommentsEmpty;
